import $ from 'jquery';

(function () {

    var self = {};

    self.$scope = $('body');

    self.toggle = function (event) {
        event.preventDefault();

        var $arrow = $(event.target);

        $arrow.toggleClass('icon-arrow-open icon-arrow-close');
        $arrow.parent().find('.categoryList-content').toggle('is-open');
    };

    self.init = function () {
        self.$scope.find('.cmsCategoryList .icon-arrow-open, .cmsCategoryList .icon-arrow-close')
            .on('click', self.toggle);
    };

    self.init();

    return self;
})();



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/categoryList.js
 **/